/**
 * London Smoke & Cure — Njord live twin (Firebase RTDB subscriptions).
 *
 * Uses shallow per-sensor paths via njordLiveHub — never the `live` root.
 */

import { subscribeNjordLiveHub, subscribeNjordLiveSensorShallow } from './njordLiveHub';
import {
    NJORD_DEFAULT_READ_INTERVAL_SEC,
    NJORD_PRESENCE_OFFLINE_INTERVALS,
    NJORD_PRESENCE_ONLINE_INTERVALS,
} from './njordConstants';

export { syncNjordLiveSensorIds, setNjordLiveTransport, getNjordLiveTransport } from './njordLiveHub';
export { NJORD_LIVE_POLL_INTERVAL_MS } from './njordLiveHub';

/**
 * @param {string} sensorId
 * @param {(data: object|null) => void} cb
 * @returns {() => void} unsubscribe
 */
export function subscribeLiveSensor(sensorId, cb) {
    return subscribeNjordLiveSensorShallow(sensorId, cb);
}

/**
 * @param {(data: Record<string, object>) => void} cb
 * @returns {() => void} unsubscribe
 */
export function subscribeAllLive(cb) {
    return subscribeNjordLiveHub(cb);
}

/**
 * Presence tier from lastBeatMs and read interval.
 * @param {number|null} lastBeatMs
 * @param {number} readIntervalSec
 */
export function presenceTier(lastBeatMs, readIntervalSec = NJORD_DEFAULT_READ_INTERVAL_SEC) {
    if (!lastBeatMs || !Number.isFinite(lastBeatMs)) return 'unknown';
    const ageSec = (Date.now() - lastBeatMs) / 1000;
    const interval = Math.max(5, readIntervalSec);
    const intervals = ageSec / interval;
    if (intervals < NJORD_PRESENCE_ONLINE_INTERVALS) return 'online';
    if (intervals < NJORD_PRESENCE_OFFLINE_INTERVALS) return 'degraded';
    return 'offline';
}
